window.addEventListener('load', () => {
    const tlMksun = document.querySelector('.mksun-timeline--entreprise');

    if (tlMksun) {
        const steps = tlMksun.querySelectorAll('.mksun-timeline--entreprise__ctn__content__left__text__item');
        const imagesSteps = tlMksun.querySelectorAll('.mksun-timeline--entreprise__ctn__content__right__img__item');
        const controlPrev = tlMksun.querySelector('.mksun-timeline--entreprise__ctn__content__left__controls__prev');
        const controlNext = tlMksun.querySelector('.mksun-timeline--entreprise__ctn__content__left__controls__next');

        const pointsCtn = tlMksun.querySelectorAll('.mksun-timeline--entreprise__ctn__tl__points div');

        const linePrimary = tlMksun.querySelector('.mksun-timeline--entreprise__ctn__tl__line__primary');

        const tlEl = tlMksun.querySelector('.mksun-timeline--entreprise__ctn__tl')

        let currentStep = 0;

        const changeStep = (step) => {
            if (step === 0) {
                controlPrev.classList.add('disabled');
            } else {
                controlPrev.classList.remove('disabled');
            }

            if (step === steps.length - 1) {
                controlNext.classList.add('disabled');
            } else {
                controlNext.classList.remove('disabled');
            }

            steps.forEach((step, index) => {
                step.classList.remove('mksun-timeline--entreprise__ctn__content__left__text__item--active');
            });
            steps[step].classList.add('mksun-timeline--entreprise__ctn__content__left__text__item--active');

            imagesSteps.forEach((img, index) => {
                img.classList.remove('mksun-timeline--entreprise__ctn__content__right__img__item--active');
            });
            imagesSteps[step].classList.add('mksun-timeline--entreprise__ctn__content__right__img__item--active');

            pointsCtn.forEach((point, index) => {
                point.classList.remove('mksun-timeline--entreprise__ctn__tl__points__point--active');
                if (index < currentStep) {
                    point.classList.add('mksun-timeline--entreprise__ctn__tl__points__point--done');
                } else {
                    point.classList.remove('mksun-timeline--entreprise__ctn__tl__points__point--done');
                }
            });

            pointsCtn[step].classList.add('mksun-timeline--entreprise__ctn__tl__points__point--active');



            // if we are < 768px we scroll to the current step in tl
            if (window.innerWidth <= 1024) {
                if(currentStep !== steps.length - 1) tlEl.style.transform = `translateX(calc(-${step * 33}vw - ${step * 10}px + 3rem))`;
                tlMksun.querySelector('.mksun-timeline--entreprise__ctn__tl__line__bg').style.width = tlMksun.querySelector('.mksun-timeline--entreprise__ctn__tl__points').offsetWidth + 'px';
                linePrimary.style.width = tlMksun.querySelector('.mksun-timeline--entreprise__ctn__tl__points').offsetWidth / (steps.length - 1) * step + 'px';
            } else {
                tlMksun.querySelector('.mksun-timeline--entreprise__ctn__tl').style.transform = `none`;
                tlMksun.querySelector('.mksun-timeline--entreprise__ctn__tl__line__bg').style.width = '100%';
                linePrimary.style.width = `${(100 / (steps.length - 1)) * step}%`;
            }

        }

        controlPrev.addEventListener('click', () => {
            if (currentStep > 0) {
                currentStep--;
            }
            changeStep(currentStep);
        });

        controlNext.addEventListener('click', () => {
            if (currentStep < steps.length - 1) {
                currentStep++;
            }
            changeStep(currentStep);
        });

        changeStep(currentStep);

        window.addEventListener('resize', () => {
            changeStep(currentStep);
        });

    }
});